const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppForms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "29px",
    viewBox: "0 0 30 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,98.431373%,98.431373%)",
      fillOpacity: 1
    },
    d: "M 5 6.042969 C 5 5.375 5.558594 4.832031 6.25 4.832031 L 23.75 4.832031 C 24.441406 4.832031 25 5.375 25 6.042969 L 25 22.957031 C 25 23.625 24.441406 24.167969 23.75 24.167969 L 6.25 24.167969 C 5.558594 24.167969 5 23.625 5 22.957031 Z M 5 6.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(55.686277%,54.11765%,54.11765%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 12.833333 14.001886 L 31.166667 14.001886 M 12.833333 21 L 31.166667 21 M 16.5 27.998114 L 27.5 27.998114 M 7.333333 6.998114 L 36.666667 6.998114 L 36.666667 35.001886 L 7.333333 35.001886 Z M 7.333333 6.998114 ",
    transform: "matrix(0.681818,0,0,0.690476,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppForms);
export default __webpack_public_path__ + "static/media/app-forms.c28d9eafe5af1e2873118c18982b7fef.svg";
export { ForwardRef as ReactComponent };